import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './loading-overlay.scss';

export const LoadingOverlay = ({ className = '' }) => (
  <div className={classNames('loading-overlay', className)}>
    <div className="spinner-container">
      <i className="icon-spinner8 loading-spinner-icon" aria-hidden />
    </div>
  </div>
);

LoadingOverlay.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};
